import { Combined_CreateInheritance } from '../commands/combined';
import Controller from './Controller';
import type Report from '../checks/Report';
import type { OrId, Specialisations } from '../commands/types';
import type { IObjectType } from '../../stores/model/metamodel/object_type';

export default class AddInheritanceController extends Controller {
  addInheritance = async (
    supertype: OrId<IObjectType>,
    subtype: OrId<IObjectType>,
    abstract: boolean,
    specialisations: Specialisations
  ): Promise<Report> => {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_CreateInheritance(
        model,
        supertype,
        subtype,
        abstract,
        specialisations
      );
      return checks;
    });
  };
}
